import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "home-new" }
const _hoisted_2 = { class: "home-hero" }
const _hoisted_3 = { class: "home-shell hero-layout" }
const _hoisted_4 = { class: "hero-copy" }
const _hoisted_5 = { class: "hero-actions hero-enter delay-3" }
const _hoisted_6 = { class: "hero-note hero-enter delay-3" }
const _hoisted_7 = {
  href: "#handwerk",
  class: "scroll-cue",
  "aria-label": "Weiter zum Inhalt"
}
const _hoisted_8 = {
  id: "handwerk",
  class: "craft-section"
}
const _hoisted_9 = { class: "home-shell craft-grid" }
const _hoisted_10 = { class: "craft-copy reveal reveal-delay" }
const _hoisted_11 = { class: "home-services" }
const _hoisted_12 = { class: "home-shell" }
const _hoisted_13 = { class: "service-showcase" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "service-number" }
const _hoisted_16 = { class: "service-info" }
const _hoisted_17 = { class: "round-arrow" }
const _hoisted_18 = { class: "team-section" }
const _hoisted_19 = { class: "home-shell team-split reveal" }
const _hoisted_20 = { class: "career-invite" }
const _hoisted_21 = { class: "reviews-new" }
const _hoisted_22 = { class: "home-shell" }
const _hoisted_23 = { class: "review-row" }
const _hoisted_24 = { class: "review-stars" }
const _hoisted_25 = { class: "final-cta" }
const _hoisted_26 = { class: "home-shell cta-inner reveal" }

import { ArrowRight, Check, ChevronDown, Phone, Quote, ShieldCheck, Sparkles, Star } from "lucide-vue-next";
import { onBeforeUnmount, onMounted } from "vue";
import "@/assets/styles/home.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const services = [
  { slug: "dachsanierung", number: "01", title: "Dachsanierung", text: "Substanz bewahren, Energie sparen und den Wert Ihres Hauses langfristig sichern." },
  { slug: "flachdacharbeiten", number: "02", title: "Flachdach", text: "Durchdachte Abdichtung, sichere Entwässerung und langlebige Details." },
  { slug: "spenglerarbeiten", number: "03", title: "Spenglerei", text: "Präzise Metallarbeiten für Anschlüsse, Rinnen und saubere Abschlüsse." }
];

const reviews = [
  { name: "Familie Schneider", place: "Mannheim", text: "Von der ersten Beratung bis zur Abnahme hatten wir jederzeit ein gutes Gefühl. Präzise, sauber und zuverlässig." },
  { name: "Michael Bauer", place: "Heidelberg", text: "Man merkt sofort, dass hier echte Fachleute arbeiten. Besonders die Kommunikation war angenehm klar." },
  { name: "Sandra Keller", place: "Ludwigshafen", text: "Nach dem Sturmschaden war das Team schnell vor Ort. Unser Dach wurde sicher und ordentlich instand gesetzt." }
];

let observer: IntersectionObserver | null = null;
onMounted(() => {
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer?.unobserve(entry.target);
      }
    });
  }, { threshold: 0.14, rootMargin: "0px 0px -40px" });
  document.querySelectorAll(".reveal").forEach((element) => observer?.observe(element));
});
onBeforeUnmount(() => observer?.disconnect());

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("img", {
        class: "hero-bg",
        src: "/images/home/hero-v2.png",
        alt: "Modernes Steildach bei Sonnenaufgang"
      }, null, -1)),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "hero-grain" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "eyebrow hero-enter" }, "Meisterbetrieb · Mannheim & Region", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "hero-enter delay-1" }, [
            _createTextVNode("Dächer, die"),
            _createElementVNode("br"),
            _createElementVNode("em", null, "Ruhe geben.")
          ], -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "hero-enter delay-2" }, "Wir verbinden ehrliches Handwerk mit klarer Planung – für Dächer, die heute überzeugen und morgen noch schützen.", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_RouterLink, {
              to: "/kontakt",
              class: "home-button accent"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Phone)),
                _cache[0] || (_cache[0] = _createTextVNode(" Projekt besprechen", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/leistungen",
              class: "home-button ghost"
            }, {
              default: _withCtx(() => [
                _cache[1] || (_cache[1] = _createTextVNode("Leistungen entdecken ", -1)),
                _createVNode(_unref(ArrowRight))
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(ShieldCheck)),
          _cache[5] || (_cache[5] = _createElementVNode("div", null, [
            _createElementVNode("strong", null, "Persönlich. Verlässlich."),
            _createElementVNode("span", null, "Ein Ansprechpartner von der Idee bis zur Abnahme.")
          ], -1))
        ])
      ]),
      _createElementVNode("a", _hoisted_7, [
        _cache[6] || (_cache[6] = _createElementVNode("span", null, "Entdecken", -1)),
        _createVNode(_unref(ChevronDown))
      ])
    ]),
    _cache[29] || (_cache[29] = _createStaticVNode("<section class=\"trust-bar\"><div class=\"home-shell trust-grid reveal\"><div><strong>15+</strong><span>Jahre Erfahrung</span></div><div><strong>420</strong><span>realisierte Dächer</span></div><div><strong>4,9</strong><span>Kundenbewertung</span></div><div><strong>100%</strong><span>Meisterqualität</span></div></div></section>", 1)),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "craft-visual reveal" }, [
          _createElementVNode("div", { class: "image-frame" }, [
            _createElementVNode("img", {
              src: "/images/home/handwerk-v2.png",
              alt: "Dachdecker prüft eine präzise Metallverkleidung"
            })
          ]),
          _createElementVNode("div", { class: "image-caption" }, [
            _createElementVNode("span", null, "01"),
            _createElementVNode("p", null, "Das gute Detail entscheidet über Jahrzehnte.")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_10, [
          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "eyebrow dark" }, "Unser Anspruch", -1)),
          _cache[14] || (_cache[14] = _createElementVNode("h2", null, "Man sieht nicht jedes Detail. Aber man spürt, wenn alles stimmt.", -1)),
          _cache[15] || (_cache[15] = _createElementVNode("p", null, "Ein gutes Dach beginnt mit Zuhören. Wir prüfen genau, erklären verständlich und empfehlen nur, was technisch und wirtschaftlich wirklich sinnvoll ist.", -1)),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_unref(Check)),
              _cache[9] || (_cache[9] = _createTextVNode("Saubere Bestandsaufnahme vor Ort", -1))
            ]),
            _createElementVNode("li", null, [
              _createVNode(_unref(Check)),
              _cache[10] || (_cache[10] = _createTextVNode("Verständliche Angebote ohne Überraschungen", -1))
            ]),
            _createElementVNode("li", null, [
              _createVNode(_unref(Check)),
              _cache[11] || (_cache[11] = _createTextVNode("Fachgerechte Ausführung bis ins Detail", -1))
            ])
          ]),
          _createVNode(_component_RouterLink, {
            to: "/ueber",
            class: "text-link"
          }, {
            default: _withCtx(() => [
              _cache[12] || (_cache[12] = _createTextVNode("Unseren Betrieb kennenlernen ", -1)),
              _createVNode(_unref(ArrowRight))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "section-intro reveal" }, [
          _createElementVNode("div", null, [
            _createElementVNode("span", { class: "eyebrow dark" }, "Leistungen"),
            _createElementVNode("h2", null, "Kompetenz für jedes Dach.")
          ]),
          _createElementVNode("p", null, "Von der ersten Prüfung bis zum letzten Anschluss denken wir Ihr Projekt als Ganzes.")
        ], -1)),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(services, (service, index) => {
            return _createVNode(_component_RouterLink, {
              key: service.slug,
              to: `/leistungen/${service.slug}`,
              class: "home-service-card reveal",
              style: _normalizeStyle({ '--delay': `${index * 110}ms` })
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: `/images/services/${service.slug}.png`,
                  alt: service.title,
                  loading: "lazy"
                }, null, 8, _hoisted_14),
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "service-shade" }, null, -1)),
                _createElementVNode("span", _hoisted_15, _toDisplayString(service.number), 1),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("h3", null, _toDisplayString(service.title), 1),
                  _createElementVNode("p", null, _toDisplayString(service.text), 1),
                  _createElementVNode("span", _hoisted_17, [
                    _createVNode(_unref(ArrowRight))
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["to", "style"])
          }), 64))
        ]),
        _createVNode(_component_RouterLink, {
          to: "/leistungen",
          class: "all-services reveal"
        }, {
          default: _withCtx(() => [
            _cache[18] || (_cache[18] = _createTextVNode("Alle Leistungen ansehen ", -1)),
            _createVNode(_unref(ArrowRight))
          ]),
          _: 1
        })
      ])
    ]),
    _cache[30] || (_cache[30] = _createStaticVNode("<section class=\"promise-section\"><div class=\"home-shell promise-grid\"><div class=\"promise-copy reveal\"><span class=\"eyebrow light\">So arbeiten wir</span><h2>Klarheit in jeder Phase.</h2><p>Keine unnötige Komplexität. Sie wissen jederzeit, was als Nächstes passiert und wer für Sie da ist.</p></div><ol class=\"steps-list\"><li class=\"reveal\"><span>01</span><div><h3>Zuhören &amp; prüfen</h3><p>Wir verstehen Ihr Vorhaben und sehen uns die Substanz genau an.</p></div></li><li class=\"reveal\"><span>02</span><div><h3>Planen &amp; erklären</h3><p>Sie erhalten eine klare Empfehlung und ein transparentes Angebot.</p></div></li><li class=\"reveal\"><span>03</span><div><h3>Umsetzen &amp; übergeben</h3><p>Wir arbeiten koordiniert, sauber und dokumentieren das Ergebnis.</p></div></li></ol></div></section>", 1)),
    _createElementVNode("section", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _cache[25] || (_cache[25] = _createStaticVNode("<div class=\"team-card\"><img src=\"/images/home/team-v2.png\" alt=\"Dachdecker-Team bespricht gemeinsam die Baupläne\" loading=\"lazy\"><div class=\"team-overlay\"></div><div class=\"team-copy\"><span class=\"eyebrow light\">Menschen, die mitdenken</span><h2>Ein Team.<br>Ein Wort.</h2><p>Erfahrene Handwerker, klare Absprachen und Respekt vor Ihrem Zuhause.</p></div></div>", 1)),
        _createElementVNode("aside", _hoisted_20, [
          _cache[21] || (_cache[21] = _createElementVNode("span", { class: "eyebrow light" }, "Komm ins Team", -1)),
          _cache[22] || (_cache[22] = _createElementVNode("h3", null, "Deine Zukunft liegt oben.", -1)),
          _cache[23] || (_cache[23] = _createElementVNode("p", null, "Ob als Fachkraft oder zum Start ins Berufsleben: Bei uns arbeitest du mit moderner Ausstattung, erfahrenen Kollegen und sichtbaren Ergebnissen.", -1)),
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "career-options" }, [
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, "Fachkräfte"),
              _createElementVNode("span", null, "Verantwortung übernehmen")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, "Ausbildung"),
              _createElementVNode("span", null, "Handwerk von Grund auf lernen")
            ])
          ], -1)),
          _createVNode(_component_RouterLink, {
            to: "/karriere",
            class: "home-button accent"
          }, {
            default: _withCtx(() => [
              _cache[20] || (_cache[20] = _createTextVNode("Jetzt bewerben ", -1)),
              _createVNode(_unref(ArrowRight))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "section-intro centered reveal" }, [
          _createElementVNode("div", null, [
            _createElementVNode("span", { class: "eyebrow dark" }, "Stimmen unserer Kunden"),
            _createElementVNode("h2", null, "Vertrauen entsteht durch Erfahrung.")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reviews, (review, index) => {
            return _createElementVNode("article", {
              key: review.name,
              class: "review-new reveal",
              style: _normalizeStyle({ '--delay': `${index * 100}ms` })
            }, [
              _createVNode(_unref(Quote)),
              _createElementVNode("div", _hoisted_24, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                  return _createVNode(_unref(Star), { key: n })
                }), 64))
              ]),
              _createElementVNode("p", null, _toDisplayString(review.text), 1),
              _createElementVNode("footer", null, [
                _createElementVNode("strong", null, _toDisplayString(review.name), 1),
                _createElementVNode("span", null, _toDisplayString(review.place), 1)
              ])
            ], 4)
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_unref(Sparkles)),
        _cache[28] || (_cache[28] = _createElementVNode("div", null, [
          _createElementVNode("span", { class: "eyebrow light" }, "Ihr Projekt"),
          _createElementVNode("h2", null, "Was können wir für Ihr Dach tun?")
        ], -1)),
        _createVNode(_component_RouterLink, {
          to: "/kontakt",
          class: "home-button accent"
        }, {
          default: _withCtx(() => [
            _cache[27] || (_cache[27] = _createTextVNode("Unverbindlich anfragen ", -1)),
            _createVNode(_unref(ArrowRight))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})